export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 9 18" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100众筹" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="WEB-/--Bundles-tab" transform="translate(-1213.000000, -789.000000)" fill="#666666">
                    <g id="-mockplus-" transform="translate(0.000000, 60.000000)">
                        <g id="编组-3" transform="translate(1213.000000, 729.914012)">
                            <path
                                d="M9,2.79716276 L6.45349334,2.79716276 C6.29069521,2.79716276 6.1395319,2.88925479 6,3.07343885 C5.86046215,3.25761028 5.79070428,3.4763099 5.79070428,3.72956298 L5.79070428,5.59433816 L9,5.59433816 L8.54651007,8.21883468 L5.79070428,8.21883468 L5.79070428,16.0923483 L2.75581599,16.0923483 L2.75581599,8.21883468 L0,8.21883468 L0,5.59433816 L2.75581599,5.59433816 L2.75581599,4.04035463 C2.75581599,2.93530081 3.10464361,1.98564912 3.80232436,1.19138695 C4.5,0.397124772 5.38371534,0 6.45349334,0 L9,0 L9,2.79716276 Z"
                                id="Fill-1"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
